import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import SwitchableView from 'components/Switchable';
import { makeStyles } from '@material-ui/core';
import COLORS from '../../../../utils/constants/colors';
import cn from 'classnames';
import Fields from './TabFields';
import { isEmpty } from 'lodash';

const useStyles = makeStyles(() => ({
  formTabs: {
    paddingTop: '0.5rem',
    paddingBottom: '0.5rem',
  },
  tabPanel: {
    border: `1px solid ${COLORS.GREY_01}`,
    padding: '1rem',
    marginBottom: '1rem',
  },
  component: {
    width: '100%',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
  },
  disabled: {
    opacity: '0.5',
  },
  hidden: {
    display: 'none',
  },
}));

export const getTabsWithFields = ({ props, tabs, id }) => {
  return tabs.map(tab => {
    return {
      label: tab.label,
      component: <Fields tab={tab} props={props} id={id} />,
    };
  });
};

const FormTabs = ({
  id,
  className,
  activeTab,
  tabs,
  formProps,
  hidden,
  disabled,
  hideTabsOnly,
}) => {
  const classes = useStyles();
  const [currentActive, setCurrentActive] = useState(activeTab);

  useEffect(() => {
    if (hidden) return;
    const currentValue = formProps.values[id];
    const active = tabs.find(item => item.label === currentActive);
    formProps.setFieldValue(id, {
      ...(!isEmpty(active) && { [currentActive]: active.initialValues }),
      ...currentValue,
      activeTab: currentActive,
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentActive, hidden]);

  useEffect(() => {
    setCurrentActive(activeTab);
  }, [activeTab]);

  return !hidden ? (
    <div
      className={cn(classes.formTabs, className, {
        [classes.disabled]: disabled,
      })}
    >
      <SwitchableView
        panelClassName={classes.tabPanel}
        tabs={getTabsWithFields({ props: formProps, tabs, id })}
        active={currentActive}
        setActive={setCurrentActive}
        hideTabsOnly={hideTabsOnly}
      />
    </div>
  ) : null;
};

FormTabs.propTypes = {
  id: PropTypes.string,
  className: PropTypes.string,
  activeTab: PropTypes.string,
  tabs: PropTypes.array,
  formProps: PropTypes.object,
  hidden: PropTypes.bool,
  disabled: PropTypes.bool,
  hideTabsOnly: PropTypes.bool,
};

export default FormTabs;
